import { put } from 'redux-saga/effects';

import { logger } from '@/config/logger';
import { tagUpdate } from '@/modules/api/codegen';
import { actions as modalActions, StaticModal } from '@/modules/modals';
import { takeLatestRequest } from '@/services/utilities/takeRequest';

import { updateTag as updateSecretTag } from '../../../../services/actions';
import { updateTag, updateTagFailure, updateTagReset, updateTagSuccess } from '../actions';

function* handler({ meta, payload }: ReturnType<typeof updateTag>, signal: AbortSignal) {
    try {
        yield tagUpdate({ tagName: meta.tag }, { newName: payload.tag }, { signal });

        yield put(updateSecretTag([meta.tag, payload.tag]));
        yield put(updateTagSuccess(meta.tag));
        yield put(modalActions.setModalVisibility(StaticModal.UPDATE_TAG, false));
    } catch (e) {
        logger.error(e);

        yield put(updateTagFailure(meta.tag, e));
    }
}

export default function* () {
    yield takeLatestRequest(
        {
            actionCreator: updateTag,
            cancelActionFunction: action => updateTagReset(action.meta.tag),
            idSelector: action => action.meta.tag,
        },
        handler,
    );
}
